const nonprofit_shifts = state => state.nonprofit_shifts
const nonprofit_shift = state => state.nonprofit_shift

export default {
  nonprofit_shifts,
  nonprofit_shift
};
